// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__Y-FoN","checkboxCol":"Table_checkboxCol__ipgs2","emailCol":"Table_emailCol__3xHlO","actionCol":"Table_actionCol__AXJ5E"};